import { ContactAddress } from '../../types';

export const getAddress = ({ contact }: ContactAddress) => {
  if (!contact) {
    return null;
  }

  const { city, state, zipCode } = contact;

  if (!city || !state || !zipCode) {
    return null;
  }

  return `${city}, ${state} ${zipCode}`;
};
